import React from 'react';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import { useFormContext } from 'react-hook-form';
import Radio from '@/components/form/Radio/Radio';
import RadioGroup from '@/components/form/RadioGroup/RadioGroup';
import Label from '@/components/form/Label/Label';
import SelectField from '@/components/form/SelectField/SelectField';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import TextField from '@/components/form/TextField/TextField';
import { CONTACT_TYPES, SUBJECT_OPTIONS } from '@/features/forms/FormContato/data';
import InputTelControlled from '@/components/form/InputTel/InputTelControlled';
import TextArea from '@/components/form/Textarea/TextArea';
import { FormContactDataType } from '@/features/forms/FormContato/validationScheme';

export interface FormProps {}

const FormContactType = ({ ...props }: FormProps) => {
  const {
    watch,
    register,
    formState: { errors, ...formState },
  } = useFormContext<FormContactDataType>();

  return (
    <>
      <Fieldset>
        <legend>Informe o seu tipo de contato</legend>
        <RadioGroup>
          <Radio
            label={CONTACT_TYPES.VIAJANTE.label}
            value={CONTACT_TYPES.VIAJANTE.value}
            {...register('contactType')}
          />
          <Radio
            label={CONTACT_TYPES.AGENCIA_DE_VIAGENS.label}
            value={CONTACT_TYPES.AGENCIA_DE_VIAGENS.value}
            {...register('contactType')}
          />
        </RadioGroup>
        {watch('contactType') === CONTACT_TYPES.AGENCIA_DE_VIAGENS.value && (
          <FieldGroup>
            <Label htmlFor="companyName" required>
              Nome da Agência / Empresa
            </Label>
            <TextField error={errors.companyName?.message} {...register('companyName')} />
          </FieldGroup>
        )}
      </Fieldset>

      <Fieldset>
        <legend>Selecione um assunto</legend>
        <FieldGroup>
          <SelectField id="subject" error={errors.subject?.message} {...register('subject')}>
            <option value="">-- selecione --</option>
            {SUBJECT_OPTIONS.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </SelectField>
        </FieldGroup>
      </Fieldset>

      {['Passagens Aéreas', 'Viagens'].includes(watch('subject')) && (
        <Fieldset>
          <legend>Informe os dados da sua viagem</legend>
          <FieldGroup>
            <Label htmlFor="origin" required>
              Cidade de origem
            </Label>
            <TextField error={errors.origin?.message} {...register('origin')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor="destination" required>
              Destino(s) que deseja visitar
            </Label>
            <TextField error={errors.destination?.message} {...register('destination')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor="dateDepart" required>
              Data de embarque prevista
            </Label>
            <TextField type="date" error={errors.dateDepart?.message} {...register('dateDepart')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor="dateReturn" required>
              Data de retorno prevista
            </Label>
            <TextField type="date" error={errors.dateReturn?.message} {...register('dateReturn')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor="paxNumber" required>
              Quantidade de passageiros
            </Label>
            <TextField type="number" error={errors.paxNumber?.message} {...register('paxNumber')} />
          </FieldGroup>
        </Fieldset>
      )}

      <Fieldset>
        <legend>Seus dados de contato</legend>
        <FieldGroup>
          <Label htmlFor="name" required>
            Nome completo
          </Label>
          <TextField id="name" error={errors.name?.message} {...register('name')} />
        </FieldGroup>
        <FieldGroup>
          <Label htmlFor="email" required>
            Email
          </Label>
          <TextField id="email" error={errors.email?.message} {...register('email')} />
        </FieldGroup>
        <InputTelControlled label="(Cod. Área) + Telefone" name="phone" error={errors.phone?.message} />
      </Fieldset>
      <Fieldset>
        <legend>Mensagem</legend>
        <FieldGroup>
          <TextArea
            id="message"
            error={errors.message?.message}
            rows={5}
            helperText="Escreva sua mensagem, envie suas dúvidas, ou ainda, se o assunto for referente sua viagem, informe detalhes como data prevista, destino e etc."
            {...register('message')}
          />
        </FieldGroup>
      </Fieldset>
    </>
  );
};

export default FormContactType;
